import * as React from 'react';
import clsx from 'clsx';

interface NavigationItemProps extends React.HTMLAttributes<HTMLButtonElement> {
    active: boolean;
    name: string;
}

const NavigationItem = React.forwardRef<HTMLButtonElement, NavigationItemProps>((
    {
        active,
        name,
        ...rest
    },
    ref
): React.ReactElement => (
    <button
        ref={ref}
        type="button"
        className={clsx(
            'softphone-navigation-item',
            active && 'active'
        )}
        {...rest}
    >
        {name}
    </button>
));

NavigationItem.displayName = 'NavigationItem';

export default NavigationItem;
